export default function genererPeriodicite() {
  return {
    libelle: null,
    code: null,
    nbJour: null,
    nbMois: null,
  };
}
